import { render } from "./WelcomeSection.vue?vue&type=template&id=ad48102c&scoped=true"
import script from "./WelcomeSection.vue?vue&type=script&lang=js"
export * from "./WelcomeSection.vue?vue&type=script&lang=js"

import "./WelcomeSection.vue?vue&type=style&index=0&id=ad48102c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad48102c"]])

export default __exports__